<div class="permission-text flex-grid">
  <div class="col"><h4 class="section-hdr flt-left" l10nTranslate>shared.recordPermissions</h4></div>
  <div class="col txt-button">
    <button class="txt-button flt-right" (click)="addRecord()" l10nTranslate>shared.addRecord</button>
    <mat-icon class="flt-right" svgIcon="add-icon"> </mat-icon>
  </div>
</div>

<table aria-hidden="true" cdk-table [dataSource]="recordPermissionsDataSource" class="recordpermiss-table">
  <ng-container cdkColumnDef="recordTypeVal">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.recordType</th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordTypeVal | uppercase }}</td>
  </ng-container>

  <ng-container cdkColumnDef="recordID">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.recordID</th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordID }}</td>
  </ng-container>

  <ng-container cdkColumnDef="recordDesc">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.description</th>
    <td cdk-cell *cdkCellDef="let record">{{ record.recordDesc }}</td>
  </ng-container>

  <ng-container cdkColumnDef="Approve/Reject" *ngIf="pageType !== 'user'">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.approveReject</th>
    <td cdk-cell *cdkCellDef="let row">
      <mat-radio-group [(ngModel)]="row.statusId">
        <mat-radio-button [value]="1" l10nTranslate>shared.approve</mat-radio-button>
        <mat-radio-button [value]="2" l10nTranslate>shared.reject</mat-radio-button>
      </mat-radio-group>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="actions">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let record">
      <button mat-icon-button (click)="deleteRecord(record.recordID)">
        <mat-icon svgIcon="del-icon"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>

<div class="no-records-message" *ngIf="recordsArray?.length === 0" l10nTranslate>shared.noRecordsFound</div>
